import { render, staticRenderFns } from "./FedExVerificationMethodStep.vue?vue&type=template&id=ab22c6f0&scoped=true"
import script from "./FedExVerificationMethodStep.vue?vue&type=script&lang=ts"
export * from "./FedExVerificationMethodStep.vue?vue&type=script&lang=ts"
import style0 from "./FedExVerificationMethodStep.vue?vue&type=style&index=0&id=ab22c6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab22c6f0",
  null
  
)

export default component.exports